import { render, staticRenderFns } from "./MantenimientoCorrectivoForm.vue?vue&type=template&id=67df45a0&scoped=true&"
import script from "./MantenimientoCorrectivoForm.vue?vue&type=script&lang=ts&"
export * from "./MantenimientoCorrectivoForm.vue?vue&type=script&lang=ts&"
import style0 from "./MantenimientoCorrectivoForm.vue?vue&type=style&index=0&id=67df45a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67df45a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('67df45a0', component.options)
    } else {
      api.reload('67df45a0', component.options)
    }
    module.hot.accept("./MantenimientoCorrectivoForm.vue?vue&type=template&id=67df45a0&scoped=true&", function () {
      api.rerender('67df45a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Correctivas/MantenimientoCorrectivoForm.vue"
export default component.exports